import { Checkbox, DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import { IEquipoDTO } from "../../../Interfaces/IEquipo";
import { useContext, useState } from "react";
import { UseEquipo } from "./UseEquipo";
import { useBoolean } from "@fluentui/react-hooks";
import { useNavigate } from "react-router-dom";
import { TableBaseComponent } from "../../../components/Table/TableBaseComponent";
import IconHelper from "../../../utils/helpers/iconHelper";
import themeBase from "../../../utils/theme/themeBase";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import { PanelEquipoFil } from "./equipoFiltro/PanelEquipoFil";
import { PanelEquipoSync } from "./EquipoSync/PanelEquipoSync";
import { AuthContext } from "../../../auth/context/auth-context";

const Equipo = () => {
   const [isOpenFiltrar, { setTrue: openPanelFiltrar, setFalse: closePanelFiltrar }] = useBoolean(false);
   const [isOpen, setIsOpen] = useState(false);
   const [isOpenSYNC, { setTrue: openPanelSYNC, setFalse: closePanelSYNC }] = useBoolean(false);
   const { hasRequiredRole } = useContext(AuthContext);
   let navigate = useNavigate();

   const [equipoId, setEquipoId] = useState<string>("");
   const { filter2, resetFilter2, onChangeComboFilter, items, buscar, filter, loading, pagination, handleResetUpdate, onChangeSearch, setSelectAllChecked, onChangeTake, selectAllChecked, handleSelectAllChange, _onkeyUpSearchTable, getEquipo, setControl } = UseEquipo();


   const buttonLeft = () => {
      let buttons: ICommandBarItemProps[] = [
         {
            ...IconHelper.ICON_RELOAD,
            text: "Actualizar",
            onClick: () => {
               handleResetUpdate()
               getEquipo()
            },
         }
      ]
      if (hasRequiredRole("lv.ADMEquipoAuxiliar")) {
         buttons.push(
            {
               ...IconHelper.ICON_RELOAD2,
               text: "Sincronizar",
               onClick: () => {
                  openPanelSYNC()
               },
            }
         )
      }
      return buttons;

   }


   const buttonRight: ICommandBarItemProps[] = [
      {
         ...IconHelper.ICON_BS_FILTER,
         text: "Buscar",
         onClick: () => {
            setIsOpen(true)
         },
      }
   ];

   function renderOpciones(item: IEquipoDTO) {

      if (!item.tieneHistorico) {
         return (
            <span style={{ color: "gray", fontSize: "12px" }}>
            </span>
         );
      }
         return (
            <>
               <TooltipHost content="Ver">
                  <Icon
                     iconName="View"
                     className={themeBase.classNamesIcon.iconFont}
                     style={{ cursor: "pointer", color: "#0078d3" }}
                     onClick={() => {
                        setEquipoId(item.equipoId)
                        navigate(`/equiposAuxiliares/listado/detalle`, { state: { equipoId: item.equipoId } });
                     }}
                  />
               </TooltipHost>
            </>
         );
      }
      const _columns = [
         {
            key: "Check",
            name: "",
            fieldName: "Check",
            minWidth: 30,
            maxWidth: 50,
            onRender: (item: IEquipoDTO, index) => <>
               <Checkbox onChange={(ev, checked) => {
                  if (checked != undefined) {
                     handleSelectAllChange(checked, item.equipoId, ev)
                  }
               }} checked={item.esVisible} />
            </>

         },
         {
            key: "numeracion",
            name: "N°",
            fieldName: "numeracion",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item, index) => {
               const startIndex = (filter.skip ?? 0);
               return <>{startIndex + (index ?? 0) + 1}</>;
            }
         },
         {
            key: "equipo",
            name: "Equipo",
            fieldName: "equipo",
            minWidth: 80,
            maxWidth: 80,
         },
         {
            key: "tipoEquipo",
            name: "Tipo de Equipo",
            fieldName: "tipoEquipo",
            minWidth: 150,
            maxWidth: 150
         },
         {
            key: "modelo",
            name: "Modelo",
            fieldName: "equipoModelo",
            minWidth: 100,
            maxWidth: 100,
         },
         {
            key: "estado",
            name: "Estado",
            fieldName: "estado",
            minWidth: 80,
            maxWidth: 80
         },
         {
            key: "razon",
            name: "Razón",
            fieldName: "razon",
            minWidth: 80,
            maxWidth: 80
         },
         {
            key: "turno",
            name: "Turno",
            fieldName: "turno",
            minWidth: 60,
            maxWidth: 60
         },
         {
            key: "ubicacion",
            name: "Ubicación",
            fieldName: "ubicacion",
            minWidth: 150,
            maxWidth: 150
         },
         {
            key: "fecha",
            name: "Último cambio de estado",
            fieldName: "fecha",
            minWidth: 160,
            maxWidth: 160
         },
         {
            key: "opciones",
            name: "Opciones",
            minWidth: 100,
            maxWidth: 100,
            fieldName: "opciones",
            onRender: (item: IEquipoDTO) => renderOpciones(item)
         },
      ]

      return (
         <>
            <CabeceraTable
               Titulo={"Equipos Auxiliares"}
               SubTitulo={"Lista de Equipos Auxiliares"}
               placeholder="Buscar Por Equipo"
               componentRef={onChangeSearch}
               onKeyUp={_onkeyUpSearchTable}
            />
            <TableBaseComponent
               leftBar={buttonLeft()}
               rigthBar={buttonRight}
               data={items}
               column={_columns}
               isLoading={loading}
               getPageSize={onChangeTake}
               pagination={pagination}
               layout={DetailsListLayoutMode.justified}
            />
            <PanelEquipoSync isOpen={isOpenSYNC} onDismiss={closePanelSYNC} reload={handleResetUpdate} />

            <PanelEquipoFil
               filter2={filter2}
               onChangeComboFilter={onChangeComboFilter}
               isOpen={isOpen}
               resetFilter2={resetFilter2}
               buscar={buscar}
               onDismiss={() => setIsOpen(false)}
            />
         </>
      )
   }

   export { Equipo }